import config from 'config';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

export const apiUrl = (route) => {
  const urlParts = config.api_server.split('/');
  urlParts.pop();
  return urlParts.join('/') + route;
};

export const fetchMediaData = (() => {
  let controller;
  let signal;

  return downloadRoute => {
    const jwt = localStorage.getItem('jwt');
    const url = apiUrl(downloadRoute);
    const headers = {
      authentication: `Bearer ${ jwt }`,
    };

    if (controller !== undefined) {
      // Cancel the previous request
      controller.abort();
    }

    // eslint-disable-next-line
    controller = new AbortController();
    signal = controller.signal;

    return fetch(url, { headers, signal });
  };
})();
